import { isFunction } from "lodash";
import Back from "../Components/svg/back.svg";
import Button from "./Button";

const ActionButtons = ({
  onNext,
  onBack,
  buttonText = "Suivant",
  disabled = false,
  buttonWidth = 366,
  icon, className
}) => {

  return (
    <div className="lmf__actions">
      {isFunction(onBack) && (
        <span className="lmf__actions--icon" onClick={onBack}>
          <img src={Back} alt="Back" />
        </span>
      )}
      {isFunction(onNext || buttonText) && (
        <Button
          type={disabled ? "white" : "primary"}
          width={buttonWidth}
          alignment="center"
          disabled={disabled}
          onClick={onNext}
          className={className}
          size="large"
        >
          <span>{buttonText}</span>
          {icon}
        </Button>
      )}
    </div>
  );
};

export default ActionButtons;
